import { t } from 'ttag'

import { Flex } from '@h2/components/layout/flex'
import { Text } from '@h2/components/typography/text'
import { Heading } from '@h2/components/typography/heading'
import { ProgressBar } from '@h2/components/display/progressBar'
import { PG, SLR, PB97T, PB80T } from '@h2/components/colors'
import { Box } from '@h2/components/layout/box'
import { TargetedRangeChart } from '@h2/components/display/targetedRangeChart'

const SkillsSummaryCard = ({ objectType, skills }) => {
  const generateArray = skill => {
    //only show both bars if the required level is greater than the user's level
    if (skill.assessedValue > skill.value) {
      return [
        {
          color: PG,
          value: (100 * skill.assessedValue) / 7
        }
      ]
    }

    return [
      {
        color: PG,
        value: (100 * skill.assessedValue) / 7
      },
      {
        color: SLR,
        value: (100 * skill.value) / 7
      }
    ]
  }
  const innerContent = () => {
    if (!skills) {
      return (
        <Text align="center">{t`You have not yet completed the skills decoder`}</Text>
      )
    }

    switch (objectType) {
      case 'cluster':
      case 'onet':
        return (
          <>
            {[...skills.skills]
              .sort((aVal, bVal) => {
                return (
                  Math.max(bVal.assessedValue, bVal.value) -
                  Math.max(aVal.assessedValue, aVal.value)
                )
              })
              .map(skill => {
                return (
                  <Flex
                    alignItems="center"
                    justifyContent="flex-end"
                    gap="10px"
                    key={`SkillBar${skill.elementId}`}
                    padding="5px"
                    width="100%">
                    <Text margin="0" size="extraSmall">
                      {skill.name}
                    </Text>
                    <Box width="250px">
                      <ProgressBar
                        hashPosition={(100 * skill.value) / 7}
                        size="large"
                        value={generateArray(skill)}
                      />
                    </Box>
                  </Flex>
                )
              })}
          </>
        )
      case 'college':
        return (
          <>
            <Box>
              <Text as="span" size="medium">
                {t`SAT`}
              </Text>
              <TargetedRangeChart
                globalMax={1600}
                globalMin={0}
                innerMin={skills.institutionSatMin}
                innerMax={skills.institutionSatMax}
                innerShadowColor={PB97T}
                size="large"
                variant="balloon"
              />
              <TargetedRangeChart
                globalMax={1600}
                globalMin={0}
                innerMin={skills.expectedSatMin}
                innerMax={skills.expectedSatMax}
                innerShadowColor={PB80T}
                size="large"
                variant="balloon"
              />
            </Box>
            <Box>
              <Text as="span" size="medium">
                {t`ACT`}
              </Text>
              <TargetedRangeChart
                globalMax={36}
                globalMin={0}
                innerMin={skills.institutionActMin}
                innerMax={skills.institutionActMax}
                innerShadowColor={PB97T}
                size="large"
                variant="balloon"
              />
              <TargetedRangeChart
                globalMax={36}
                globalMin={0}
                innerMin={skills.expectedActMin}
                innerMax={skills.expectedActMax}
                innerShadowColor={PB80T}
                size="large"
                variant="balloon"
              />
            </Box>
          </>
        )
      default:
        return <Text align="center">{`This information is not available`}</Text>
    }
  }

  return (
    <div>
      <Heading level="5">{t`Preparation`}</Heading>
      {innerContent()}
    </div>
  )
}

export { SkillsSummaryCard }
